
import React from "react";
import { Helmet } from "react-helmet";
import "../css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Mumbai Airport Cab | Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions for Mumbai Airport Cab services including airport transfers, local rides, outstation trips, rentals, and corporate travel."
        />
      </Helmet>

      {/* Breadcrumb */}


 <div
      className="breadcumb-wrapper"
      style={{
        backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="container z-index-common">
        <div className="breadcumb-content">
          <h1 className="breadcumb-title">Terms & Conditions</h1>

        </div>
      </div>
    </div>


     

      {/* Terms Section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">

            <img
              src="/images/term.png"
              alt="Terms and Conditions - Mumbai Airport Cab"
            />

            <div className="col-md-12">
              <div className="terms-content">

                <p>
                  <b className="highlight">1. Booking Confirmation:</b>
                  <br />
                  All bookings with Mumbai Airport Cab are subject to vehicle
                  availability. A booking is confirmed only after receiving
                  confirmation from our system or support team.
                </p>

                <p>
                  <b className="highlight">2. Service Usage:</b>
                  <br />
                  Mumbai Airport Cab services are strictly for passenger
                  transportation. Carrying illegal, hazardous, or restricted
                  items is prohibited.
                </p>

                <p>
                  <b className="highlight">3. Payment Policy:</b>
                  <br />
                  Payments can be made through UPI, cards, net banking, wallets,
                  or cash. Advance payment may be required for airport,
                  outstation, and corporate bookings.
                </p>

                <p>
                  <b className="highlight">4. Cancellation & Rescheduling:</b>
                  <br />
                  Cancellations should be communicated as early as possible.
                  Cancellation charges may apply depending on booking type and timing.
                </p>

                <p>
                  <b className="highlight">5. Customer Responsibility:</b>
                  <br />
                  Customers must provide accurate pickup and drop-off details,
                  contact information, and travel schedules.
                </p>

                <p>
                  <b className="highlight">6. Seating & Luggage:</b>
                  <br />
                  Passengers must not exceed the vehicle seating capacity.
                  Additional luggage may require a larger vehicle and extra charges.
                </p>

                <p>
                  <b className="highlight">7. Driver Duty Hours:</b>
                  <br />
                  Driver working hours comply with transport regulations.
                  Long-distance trips may require additional driver allowances.
                </p>

                <p>
                  <b className="highlight">8. Safety Guidelines:</b>
                  <br />
                  Passengers are expected to follow safety instructions and
                  avoid any damage to the vehicle.
                </p>

                <p>
                  <b className="highlight">9. Right to Refuse Service:</b>
                  <br />
                  Mumbai Airport Cab reserves the right to refuse service in
                  cases of abusive, unsafe, or illegal behavior.
                </p>

                <p>
                  <b className="highlight">10. Fare Policy:</b>
                  <br />
                  Fare estimates may vary due to tolls, parking charges,
                  waiting time, route changes, or customer requests.
                </p>

                <p>
                  <b className="highlight">11. Jurisdiction:</b>
                  <br />
                  Any disputes shall be subject to the jurisdiction of
                  Pune, Maharashtra, India.
                </p>

                <h3>Rental Policy</h3>

                <p>
                  <b className="highlight">Services Offered:</b>
                  <br />
                  Mumbai Airport Cab provides airport transfers, local rides,
                  outstation trips, corporate travel, rentals, and customized
                  transportation solutions.
                </p>

                <p>
                  <b className="highlight">Vehicle Allocation:</b>
                  <br />
                  Vehicles are allocated based on availability. Equivalent
                  or upgraded vehicles may be provided when necessary.
                </p>

                <p>
                  <b className="highlight">Toll, Parking & Taxes:</b>
                  <br />
                  Toll charges, parking fees, and applicable state taxes
                  are payable by the customer unless otherwise included.
                </p>

                <p>
                  <b className="highlight">Night Charges:</b>
                  <br />
                  Additional charges may apply for late-night travel.
                </p>

                <h3>Refund Policy</h3>

                <p>
                  <b className="highlight">Refund Eligibility:</b>
                  <br />
                  Refunds are subject to cancellation timing and booking category.
                </p>

                <p>
                  <b className="highlight">Processing Time:</b>
                  <br />
                  Approved refunds are processed within 5–7 business days.
                </p>

                <p>
                  <b className="highlight">Non-Refundable Charges:</b>
                  <br />
                  Convenience fees, service charges, and promotional discounts
                  may be non-refundable.
                </p>

                <p>
                  <b className="highlight">No-Show Policy:</b>
                  <br />
                  No refunds will be provided for missed pickups or no-show bookings.
                </p>

              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Mumbai Airport Cab</h2>

            <p>
              For bookings, airport transfers, and travel assistance,
              contact Mumbai Airport Cab:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919545731161">+91 9545731161</a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@mumbaiairportcabs.com">
                  booking@mumbaiairportcabs.com
                </a>
              </li>

              <li>
                <b>Address:</b>
                <br />
                Mumbai Airport Cab,
                <br />
                SAWANT SADAN 05 Ramachandra cold drinks<br /> House,
                  Near SBI Bank Nehru Road<br /> Opp Noble Medical,
                  Vile Parle<br /> East Mumbai - 400057
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
